import { TotalApplicants } from "../../../entities/applicant";
import ApplicantRepository from "../../ports/applicantRepository";

export type fetchTotalApplicantsUsecase = () => Promise<TotalApplicants>;

export const buildFetchTotalApplicants = (dependencies: {
  applicantRepo: ApplicantRepository;
}): fetchTotalApplicantsUsecase => {
  const { applicantRepo } = dependencies;

  const fetchTotalApplicants: fetchTotalApplicantsUsecase = async () => applicantRepo.fetchTotalApplicants();

  return fetchTotalApplicants;
};
